import { render, staticRenderFns } from "./Propostas.vue?vue&type=template&id=25ab49e8&scoped=true"
import script from "./Propostas.vue?vue&type=script&lang=js"
export * from "./Propostas.vue?vue&type=script&lang=js"
import style0 from "./Propostas.vue?vue&type=style&index=0&id=25ab49e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab49e8",
  null
  
)

export default component.exports